const state = {
  paxel_big_excellence: [],
  paxel_big_excellence_id: [],
};

export default state;
